(() => {
  
  if (document.querySelector('[data-lp-night-cream-product]')) {
    return;
  }

  if (window.__serlinoCartSyncInstalled) return;
  window.__serlinoCartSyncInstalled = true;

  const originalFetch = window.fetch;
  let nativeUpdateCount = 0;
  let pendingRefresh;

  document.addEventListener('cart:update', (event) => {
    if (!event.detail?.data?.didError) {
      nativeUpdateCount++;
    }
  }, true);

  async function refreshCartDrawer() {
    const oldDrawer = document.querySelector(
      'cart-drawer-component'
    );

    const section = oldDrawer?.closest('.shopify-section');
    if (!oldDrawer || !section?.id) return;

    const sectionId = section.id.replace(
      /^shopify-section-/, ''
    );

    const response = await originalFetch.call(
      window,
      `${location.origin}/?sections=${encodeURIComponent(sectionId)}`,
      {
        cache: 'no-store',
        credentials: 'same-origin'
      }
    );

    if (!response.ok) {
      throw new Error('Cart section refresh failed');
    }

    const data = await response.json();
    const container = document.createElement('div');

    container.innerHTML = data[sectionId] || '';

    const freshDrawer = container.querySelector(
      'cart-drawer-component'
    );

    if (!freshDrawer) {
      throw new Error('Fresh cart drawer not found');
    }

    oldDrawer.replaceWith(freshDrawer);

    await customElements.whenDefined('cart-drawer-component');

    if (freshDrawer.hasAttribute('auto-open')) {
      freshDrawer.open();
    }
  }

  window.fetch = function (...args) {
    const input = args[0];
    const options = args[1];

    let url;
    try {
      url = new URL(
        typeof input === 'string'
          ? input
          : input?.url || String(input),
        location.href
      );
    } catch {
      return originalFetch.apply(this, args);
    }

    const method = String(
      options?.method || input?.method || 'GET'
    ).toUpperCase();

    const isCartAdd =
      url.origin === location.origin &&
      method === 'POST' &&
      /\/cart\/add(?:\.js)?$/.test(url.pathname);

    if (!isCartAdd) {
      return originalFetch.apply(this, args);
    }

    const previousUpdates = nativeUpdateCount;

    return originalFetch.apply(this, args).then(response => {
      if (!response.ok) return response;

      clearTimeout(pendingRefresh);

      pendingRefresh = setTimeout(() => {
        if (nativeUpdateCount !== previousUpdates) return;

        refreshCartDrawer().catch(error => {
          console.error('[Serlino cart sync]', error);
        });
      }, 650);

      return response;
    });
  };
})();
